import { render, staticRenderFns } from "./soanThu.vue?vue&type=template&id=ada52c2a&scoped=true&"
import script from "./soanThu.vue?vue&type=script&lang=js&"
export * from "./soanThu.vue?vue&type=script&lang=js&"
import style0 from "./soanThu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./soanThu.vue?vue&type=style&index=1&id=ada52c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada52c2a",
  null
  
)

export default component.exports